<template>
    <div>
        <div class="option-title" v-if="!showPlaneMode">Trocas e Devoluções</div>
        <div class="option-title-edit" v-else>
            <ul>
                <li><strong>Trocas e Devoluções</strong></li>
            </ul>
        </div>
        <div class="frame-option" :class="[!showPlaneMode ? 'disable-styles px-4' : 'edit-styles']">
            <li>
                <p class="option-subtitle">
                    Como o cliente faz para devolver ou trocar um produto ou pedido?
                </p>
                <p>
                    O prazo para solicitação de devolução é de até 7 dias corridos após o
                    recebimento do produto. Em caso de defeito, o prazo para solicitação de troca é
                    de 30 dias após o recebimento do produto. A devolução ou troca deve ser
                    solicitada pelo titular do cadastro da compra, fazendo login na sua conta no
                    site, no menu: "Trocas e Devoluções" e cadastrando pelo botão "Solicitar
                    Troca/Devolução". Para mais informações, consulte a nossa
                    <a
                        href="https://umapenca.com/central-de-ajuda/"
                        target="_blank"
                        class="option-link"
                        >Central de Ajuda</a
                    >.
                </p>
            </li>

            <li>
                <p class="option-subtitle">Quem arca com os custos de devoluções?</p>
                <p>
                    Qualquer cliente poderá solicitar a devolução de seu pedido até 7 dias após a
                    chegada. Criaremos um código de devolução do pedido e o cliente o fará de forma
                    gratuita. Para produtos com defeito, o prazo de solicitação será de 30 dias.
                </p>
            </li>

            <li>
                <p class="option-subtitle">
                    Se o pedido da minha loja for devolvido, eu ainda ganho comissão?
                </p>
                <p>
                    Em caso de devolução ou cancelamento da compra, você deixa de receber a comissão
                    pela venda, uma vez que precisaremos fazer o reembolso ao cliente.
                </p>
            </li>

            <li>
                <p class="option-subtitle">Como é o processo de devolução e reembolso?</p>
                <p>
                    O cliente terá 7 dias após o recebimento do pedido para abrir uma solicitação.
                    Após a demanda ser gerada, o cliente terá até 15 dias para fazer o envio do
                    pedido. Ao chegar em nossa central de distribuição, ele passa por uma avaliação
                    de integridade. Concluído esse processo, o estorno é feito em até 7 dias úteis.
                </p>
                <p>
                    *Todas as peças produzidas que apresentarem qualquer tipo de avaria ou forem
                    resultado de trocas ou devoluções serão disponibilizadas para venda em um bazar
                    anualmente na cidade de Juiz de Fora.
                </p>
            </li>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PartnerExchangeTerms',

        props: {
            showPlaneMode: {
                default: false,
                type: Boolean,
            },
        },
    };
</script>
